import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid, Modal, Typography, TextField, FormControlLabel, Checkbox, Stack } from "@mui/material";

import { Button, Alert } from "../../../common/styled";
import ModalBox from "../../../../common/ModalBox";

import useLLMConfig from "../../../../../hooks/user/useLLMConfig";

function JSONModal({ open, handleClose, zoneUid }) {
  const { llmOutputScanners, configLLMSettingOutputScanners } = useLLMConfig();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        repair: llmOutputScanners ? llmOutputScanners?.json?.repair : false,
        required_elements: llmOutputScanners ? llmOutputScanners?.json?.required_elements : 0,
      }}
      validationSchema={Yup.object().shape({
        repair: Yup.bool(),
        required_elements: Yup.number().integer('Required elements must be an integer').min(0, "Required elements must be at least 0"),
      })}
      onSubmit={async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        try {
          values.submit = undefined;
          await configLLMSettingOutputScanners(zoneUid, "json", values);
          handleClose();
          resetForm();
        } catch (error) {
          const message = error.message || "Something went wrong";
          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting, touched, values }) => (
        <React.Fragment>
          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleClose();
              }
            }}
          >
            <ModalBox sx={{ width: "60vw" }} title="Edit JSON Scanner" handleClose={handleClose}>
              <form noValidate onSubmit={handleSubmit}>
                <Grid container p={4} spacing={3}>
                  <Grid item xs={12}>
                    {errors.submit && (
                      <Alert mt={2} mb={3} variant="outlined" severity="error">
                        {errors.submit}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Required Elements</Typography>
                      <TextField
                        fullWidth
                        name="required_elements"
                        type="number"
                        error={Boolean(touched.required_elements && errors.required_elements)}
                        helperText={touched.required_elements && errors.required_elements}
                        value={values.required_elements}
                        onBlur={(e) => {
                          if (e.target.value === "") setFieldValue("required_elements", 0);
                        }}
                        onChange={handleChange}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6} mt={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="repair"
                          checked={values.repair}
                          error={Boolean(touched.repair && errors.repair)}
                          helperText={touched.repair && errors.repair}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          color="primary"
                        />
                      }
                      label="Repair"
                    />
                  </Grid>
                  <Grid item xs={12} textAlign={"right"} pt={4}>
                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
                      <Button variant="outlined" color="secondary" size="modal" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button type="submit" variant="contained" color="success" size="modal" disabled={isSubmitting}>
                        Save
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </form>
            </ModalBox>
          </Modal>
        </React.Fragment>
      )}
    </Formik>
  );
}

export default JSONModal;
